/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioBase
 */
export interface PortfolioBase {
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    accountAlias?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    accountGroupGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    accountGroupName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    householdGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    householdName?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    nav: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    cash: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    cashFuturesMargin?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    reviewStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isSuspended?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    suspendedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isOnboarded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isMirrorLinked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    linkedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    openDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    referencePortfolio?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    accountType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isTaxable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    managementType?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    taxBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    taxBudgetYear?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    shortTermCapGainsTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    longTermCapGainsTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    effectiveTaxRate?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    targetEndDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioBase
     */
    initialSecuredness?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    ndvrPortfolioType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isTaxLossHarvesting?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isDirectStock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isGlobalBeta?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isPaydayBond?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isGrowthBond?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isLeveredBondEtf?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isBondFutures?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isBondFuturesOption?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isVix?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isHedgedEquity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isShortTermTreasury?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isClientDirected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isCashOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isTestAccount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioBase
     */
    isUniverseAccount?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioBase
     */
    brokerId: string;
}

/**
 * Check if a given object implements the PortfolioBase interface.
 */
export function instanceOfPortfolioBase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "nav" in value;
    isInstance = isInstance && "cash" in value;
    isInstance = isInstance && "brokerId" in value;

    return isInstance;
}

export function PortfolioBaseFromJSON(json: any): PortfolioBase {
    return PortfolioBaseFromJSONTyped(json, false);
}

export function PortfolioBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pId': json['p_id'],
        'tradeDate': json['trade_date'],
        'aC': json['a_c'],
        'accountAlias': !exists(json, 'account_alias') ? undefined : json['account_alias'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'accountGroupGuid': !exists(json, 'account_group_guid') ? undefined : json['account_group_guid'],
        'accountGroupName': !exists(json, 'account_group_name') ? undefined : json['account_group_name'],
        'householdGuid': !exists(json, 'household_guid') ? undefined : json['household_guid'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'nav': json['nav'],
        'cash': json['cash'],
        'cashFuturesMargin': !exists(json, 'cash_futures_margin') ? undefined : json['cash_futures_margin'],
        'reviewStatus': !exists(json, 'review_status') ? undefined : json['review_status'],
        'isSuspended': !exists(json, 'is_suspended') ? undefined : json['is_suspended'],
        'suspendedAt': !exists(json, 'suspended_at') ? undefined : json['suspended_at'],
        'isOnboarded': !exists(json, 'is_onboarded') ? undefined : json['is_onboarded'],
        'isMirrorLinked': !exists(json, 'is_mirror_linked') ? undefined : json['is_mirror_linked'],
        'linkedDate': !exists(json, 'linked_date') ? undefined : json['linked_date'],
        'openDate': !exists(json, 'open_date') ? undefined : json['open_date'],
        'referencePortfolio': !exists(json, 'reference_portfolio') ? undefined : json['reference_portfolio'],
        'accountType': !exists(json, 'account_type') ? undefined : json['account_type'],
        'isTaxable': !exists(json, 'is_taxable') ? undefined : json['is_taxable'],
        'managementType': !exists(json, 'management_type') ? undefined : json['management_type'],
        'taxBudget': !exists(json, 'tax_budget') ? undefined : json['tax_budget'],
        'taxBudgetYear': !exists(json, 'tax_budget_year') ? undefined : json['tax_budget_year'],
        'shortTermCapGainsTaxRate': !exists(json, 'short_term_cap_gains_tax_rate') ? undefined : json['short_term_cap_gains_tax_rate'],
        'longTermCapGainsTaxRate': !exists(json, 'long_term_cap_gains_tax_rate') ? undefined : json['long_term_cap_gains_tax_rate'],
        'effectiveTaxRate': !exists(json, 'effective_tax_rate') ? undefined : json['effective_tax_rate'],
        'targetEndDate': !exists(json, 'target_end_date') ? undefined : json['target_end_date'],
        'initialSecuredness': !exists(json, 'initial_securedness') ? undefined : json['initial_securedness'],
        'ndvrPortfolioType': !exists(json, 'ndvr_portfolio_type') ? undefined : json['ndvr_portfolio_type'],
        'isTaxLossHarvesting': !exists(json, 'is_tax_loss_harvesting') ? undefined : json['is_tax_loss_harvesting'],
        'isDirectStock': !exists(json, 'is_direct_stock') ? undefined : json['is_direct_stock'],
        'isGlobalBeta': !exists(json, 'is_global_beta') ? undefined : json['is_global_beta'],
        'isPaydayBond': !exists(json, 'is_payday_bond') ? undefined : json['is_payday_bond'],
        'isGrowthBond': !exists(json, 'is_growth_bond') ? undefined : json['is_growth_bond'],
        'isLeveredBondEtf': !exists(json, 'is_levered_bond_etf') ? undefined : json['is_levered_bond_etf'],
        'isBondFutures': !exists(json, 'is_bond_futures') ? undefined : json['is_bond_futures'],
        'isBondFuturesOption': !exists(json, 'is_bond_futures_option') ? undefined : json['is_bond_futures_option'],
        'isVix': !exists(json, 'is_vix') ? undefined : json['is_vix'],
        'isHedgedEquity': !exists(json, 'is_hedged_equity') ? undefined : json['is_hedged_equity'],
        'isShortTermTreasury': !exists(json, 'is_short_term_treasury') ? undefined : json['is_short_term_treasury'],
        'isClientDirected': !exists(json, 'is_client_directed') ? undefined : json['is_client_directed'],
        'isCashOnly': !exists(json, 'is_cash_only') ? undefined : json['is_cash_only'],
        'isTestAccount': !exists(json, 'is_test_account') ? undefined : json['is_test_account'],
        'isUniverseAccount': !exists(json, 'is_universe_account') ? undefined : json['is_universe_account'],
        'brokerId': json['broker_id'],
    };
}

export function PortfolioBaseToJSON(value?: PortfolioBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'p_id': value.pId,
        'trade_date': value.tradeDate,
        'a_c': value.aC,
        'account_alias': value.accountAlias,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'account_group_guid': value.accountGroupGuid,
        'account_group_name': value.accountGroupName,
        'household_guid': value.householdGuid,
        'household_name': value.householdName,
        'nav': value.nav,
        'cash': value.cash,
        'cash_futures_margin': value.cashFuturesMargin,
        'review_status': value.reviewStatus,
        'is_suspended': value.isSuspended,
        'suspended_at': value.suspendedAt,
        'is_onboarded': value.isOnboarded,
        'is_mirror_linked': value.isMirrorLinked,
        'linked_date': value.linkedDate,
        'open_date': value.openDate,
        'reference_portfolio': value.referencePortfolio,
        'account_type': value.accountType,
        'is_taxable': value.isTaxable,
        'management_type': value.managementType,
        'tax_budget': value.taxBudget,
        'tax_budget_year': value.taxBudgetYear,
        'short_term_cap_gains_tax_rate': value.shortTermCapGainsTaxRate,
        'long_term_cap_gains_tax_rate': value.longTermCapGainsTaxRate,
        'effective_tax_rate': value.effectiveTaxRate,
        'target_end_date': value.targetEndDate,
        'initial_securedness': value.initialSecuredness,
        'ndvr_portfolio_type': value.ndvrPortfolioType,
        'is_tax_loss_harvesting': value.isTaxLossHarvesting,
        'is_direct_stock': value.isDirectStock,
        'is_global_beta': value.isGlobalBeta,
        'is_payday_bond': value.isPaydayBond,
        'is_growth_bond': value.isGrowthBond,
        'is_levered_bond_etf': value.isLeveredBondEtf,
        'is_bond_futures': value.isBondFutures,
        'is_bond_futures_option': value.isBondFuturesOption,
        'is_vix': value.isVix,
        'is_hedged_equity': value.isHedgedEquity,
        'is_short_term_treasury': value.isShortTermTreasury,
        'is_client_directed': value.isClientDirected,
        'is_cash_only': value.isCashOnly,
        'is_test_account': value.isTestAccount,
        'is_universe_account': value.isUniverseAccount,
        'broker_id': value.brokerId,
    };
}

